import Skeleton from '@carvana/ds-skeleton';
import SectionWrapper from '@/home/common/SectionWrapper';
import {
  FinanceLoadingCard,
  TradeLoadingCard
} from '@/home/ReturnUser/HeroCards/Cards';
import {
  FinanceTradeWrapper,
  GridWrapper,
  HeroFavoriteAndSearchCard
} from '@/home/ReturnUser/HeroCards/HeroCards.styles';
import LinksLoadingCard, {
  LinkCardType
} from '@/home/ReturnUser/HeroCards/LinkCards/LinksLoadingCard';
import {
  Band,
  BandContent,
  BandHeading,
  SearchWrapper
} from './KeepShoppingBand/KeepShoppingBand.styles';
import { BASE_HERO_HEIGHT } from './OrderStatusModule.masks';

export default function OrderStatusModuleSkeleton() {
  return (
    <div className="flex w-full flex-col bg-background-default">
      <div className="sm:hidden">
        <Skeleton height={210} width="100%" />
        <div className="mx-auto w-full max-w-[1352px] p-2xl">
          <div className="flex flex-col gap-lg">
            <Skeleton height={28} width="55%" />
            <Skeleton height={18} width="80%" />
            <Skeleton height={18} width="65%" />
            <Skeleton className="mt-lg rounded-full" height={44} width="100%" />
          </div>
        </div>
      </div>

      <div
        className="relative hidden w-full bg-background-default sm:block"
        style={{ height: BASE_HERO_HEIGHT }}
      >
        <div className="relative mx-auto flex h-full w-full max-w-[1352px] items-center pl-4xl">
          <Skeleton
            className="absolute right-4xl top-2xl"
            height={BASE_HERO_HEIGHT - 48}
            width="45%"
          />
          <div className="flex w-full max-w-[420px] flex-col gap-lg md:max-w-[480px]">
            <Skeleton height={32} width="60%" />
            <Skeleton height={20} width="85%" />
            <Skeleton height={20} width="70%" />
            <Skeleton className="mt-lg rounded-full" height={48} width="55%" />
          </div>
        </div>
      </div>

      <Band>
        <BandContent>
          <BandHeading>Looking for something different?</BandHeading>
          <SearchWrapper>
            <Skeleton className="rounded-full" height={48} width="100%" />
          </SearchWrapper>
        </BandContent>
      </Band>

      <SectionWrapper
        analyticsSection="Hero Cards"
        className="pt-24 sm:pt-4xl"
        hasSideSpacing
        hasBottomSpacing
      >
        <GridWrapper>
          <HeroFavoriteAndSearchCard>
            <LinksLoadingCard card={LinkCardType.VDP} />
          </HeroFavoriteAndSearchCard>
          <HeroFavoriteAndSearchCard>
            <LinksLoadingCard card={LinkCardType.SRP} />
          </HeroFavoriteAndSearchCard>
          <FinanceTradeWrapper>
            <FinanceLoadingCard />
            <TradeLoadingCard />
          </FinanceTradeWrapper>
        </GridWrapper>
      </SectionWrapper>
    </div>
  );
}
